import { render } from "./TableCabinas.vue?vue&type=template&id=4f9054ab"
import script from "./TableCabinas.vue?vue&type=script&lang=js"
export * from "./TableCabinas.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Danben\\Proyectos\\Demos\\duchas-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__